import React,{ Component } from "react";
import i18next from "i18next";
import { setGuestPreferedLang } from '../action/homeAction'
import { connect } from 'react-redux';
import {setGuestDeviceLang} from '../action/action';
import {popupOpenClose} from '../../action/action';
import { sendAnalytics } from "../../action/homeAction"
import { APP_LAYOUT } from "../../config/constant";
import { getDefaultAnalyticsLabel } from "../JS/utility";
class SelectLanguagePopup extends Component{

    constructor(props){
        super(props);
        this.state = {
            showLangDropdown:false,
            selectedLang:null,
            languageList: []
        }
    }

    selectLangHandler = value => {
        let langCode 
        // switch(value){
        //     case 'English': langCode = 'en';
        //         break;
        //     case 'Spanish': langCode = 'es';
        //         break;
        //     case 'French': langCode = 'fr';
        //         break;
        //     case 'Traditional Chinese': langCode = 'zh_CHT';
        //         break;
        //     case 'Simplified Chinese': langCode = 'zh_CHS';
        //         break;
        // }

        this.props.languagelistData.map( langObj => {
            if(langObj.language == value){
                langCode = langObj.languageCode
                localStorage.setItem('GuestPreferedLangName', langObj.language)
            }
        })

        setGuestPreferedLang(langCode);
        localStorage.setItem('GuestPreferedLang', langCode);
        if(window.FirebasePlugin){
            window.FirebasePlugin.setCrashlyticsCustomKey('GuestSelectedLang', langCode);
        }
        this.setState({showLangDropdown:false})
        this.setState({selectedLang:value})
        i18next.changeLanguage(langCode)

        // Send Analytics
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            this.props.guestDetail, 
            APP_LAYOUT, 
            langCode, 
            {...label, "layoutLanguage": value, "layoutName": localStorage.getItem("LayoutMaster")}, 
            0, 
            this.props.guestIsLoggedIn        );
        //
    }

    componentDidMount(){
        
        // this.props.languagelistData.map( langObj => {
        //     if(langObj.languageCode == this.props.guestDeviceLang.slice(0,2)){
        //         setGuestPreferedLang(langObj.languageCode);
        //         localStorage.setItem('GuestPreferedLang', langCode);
        //     }
        // })
    }

    render(){
        let langCode = localStorage.getItem('GuestPreferedLang');
        const { t } = this.props;   
        return(
            <section class="overlay">{console.log('this.props.languagelistData',this.props.languagelistData)}
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title w-65">
                                    <h2 style={{color: "#000" }}>Preferred language</h2>
                                    <p>Select your preferred language.</p>
                                    <p>You can change this by tapping on the profile icon in the upper right corner.</p>
                                </div>
                                <div class="overlay-header-icon w-35">
                                    <i class="fas fa-language" style={{fontSize: "300%"}}></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls form-row margin-top-0 align-left">
                            <label>Set preferred language:</label>
                            <div class="custom-select">
                                <div className={`select-selected ${this.state.showLangDropdown ? "select-arrow-active" : ""}`} onClick = {() => this.setState(prev => ({showLangDropdown: !prev.showLangDropdown}))}>
                                    {this.state.selectedLang ? this.state.selectedLang : "Please select"}
                                </div>
                                <div className={`select-items ${this.state.showLangDropdown ? "" : "select-hide"}`}>
                                    {this.props.languageList.map(el=> (
                                        <div key={el} onClick={() => this.selectLangHandler(el)}>{el}</div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls">
                            <button class="button w-100" onClick={() => {
                                if(this.state.selectedLang){
                                    langCode && window.location.reload() //: localStorage.setItem('GuestPreferedLang', 'en')
                                } else {
                                    this.props.popupOpenClose(true, 'Please select prefered language')
                                }
                                // window.location.reload()
                            }}>Save</button>
                        </div>
                            <div class="overlay-controls margin-bottom-1">
                            <div class="row">
                                <div class="col col-2">
                                    <div class="w-65 align-left italic padding-right-1">*To update your preferred language, click the profile photo/icon on the upper right corner</div>
                                    <div class="w-25">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 229.71 229.71"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle class="cls-1" cx="114.85" cy="85.57" r="39.98" transform="translate(-7.87 11.73) rotate(-5.65)"/><path class="cls-1" d="M114.85,0A114.86,114.86,0,1,0,229.71,114.85,114.85,114.85,0,0,0,114.85,0Zm70.93,175.05a14.92,14.92,0,0,0-.11-4.94C168,129.18,114.85,131.3,114.85,131.3S61.69,129.18,44,170.11a15.1,15.1,0,0,0-.1,4.94,93,93,0,1,1,141.85,0Z"/></g></g></svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        guestPreferedLang: state.store2.guestPreferedLang,
        languageCodeList: state.store.home.languageCodeList,
        languageList: state.store.home.languageList,
        languagelistData: state.store.home.languagelistData,
        guestDeviceLang: state.store2.guestDeviceLang,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(
    mapStateToProps,
    {
        setGuestDeviceLang,
        popupOpenClose,
        sendAnalytics
    }
)(SelectLanguagePopup);